<template>
  <DashboardWidget 
    :title="`Recut Cost For ${currentMonthName}`"
    icon="fa-sync"
    widgetBackgroundClass="widget-bg7">
    <template v-slot:value>
      {{summaryData.recutPanelTotalValue | formatCurrency}}
    </template>
    <template v-slot:subValue>
      In {{summaryData.recutPanelTotalCount}} panel{{summaryData.recutPanelTotalCount | displayCountPlural}} recut, {{summaryData.recutPanelPercent | formatPercent}} of panels processed
    </template>
  </DashboardWidget>
</template>

<script>
import moment from 'moment'
import DashboardWidget from '@/components/dashboard/dashboardWidget'

export default {
  name: 'StationMonthlyRecutWidget',
  components: {
    DashboardWidget
  },
  props: {
    startDate: String,
    summaryData: Object
  },
  computed: {
    currentMonthName() {
      return moment(this.startDate).local().format('MMMM')
    }
  }
  
}
</script>